"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformBreakpointToEmNumber = void 0;
const Breakpoint_1 = require("../Breakpoint");
function transformBreakpointToEmNumber(breakpoint) {
    if (breakpoint === Breakpoint_1.Breakpoint.sm) {
        return 40;
    }
    if (breakpoint === Breakpoint_1.Breakpoint.md) {
        return 60;
    }
    if (breakpoint === Breakpoint_1.Breakpoint.lg) {
        return 75;
    }
    if (breakpoint === Breakpoint_1.Breakpoint.xl) {
        return 110;
    }
    return 0; // breakpoint == Breakpoint.xs
}
exports.transformBreakpointToEmNumber = transformBreakpointToEmNumber;
//# sourceMappingURL=transformBreakpointToEmNumber.js.map